import { Badge } from "@/components/ui/badge";
import { Shield, Award, Building2, Car, Zap, ShoppingBag, Tv, LandPlot, Truck, Heart, Smartphone, Store, Factory, TestTube, Banknote } from "lucide-react";

const ClientLogos = () => {
  const clientCategories = [
    {
      category: "Software and Platforms",
      icon: Building2,
      clients: [
        { name: "Cyient" },
        { name: "GT" },
        { name: "Thoucentric" },
        { name: "Qualitest" },
        { name: "Valantic" },
        { name: "Coforge" },
        { name: "Arkonify" },
        { name: "LogicaCloud" },
        { name: "Intuceo" },
        { name: "Infoshare Systems" },
        { name: "Knack Systems" },
        { name: "Knack Systems" },
        { name: "Vedminds" },
        { name: "Zucitech" },
        { name: "Transgourmet" },
        { name: "Vivaan" }
      ]
    },
    {
      category: "Fintech",
      icon: Banknote,
      clients: [
        { name: "YesBank" },
        { name: "Prodevans" }
      ]
    },
    {
      category: "Automotive",
      icon: Car,
      clients: [
        { name: "Mavi.io" },
      ]
    },
    {
      category: "Energy",
      icon: Zap,
      clients: [
        { name: "Utopus Insights" }
      ]
    },
    {
      category: "Consumer Goods and Services",
      icon: ShoppingBag,
      clients: [
        { name: "Mamenta" },
        { name: "Qreams" },
        { name: "Kagina" },
        { name: "Pristine" },
        { name: "Smyths" },
        { name: "aLL" }
      ]
    },
    {
      category: "Media & Entertainment",
      icon: Tv,
      clients: [
        { name: "Smartkauf" }
      ]
    },
    {
      category: "Public Service",
      icon: LandPlot,
      clients: [
        { name: "BWSSB" }
      ]
    },
    {
      category: "Logistics",
      icon: Truck,
      clients: [
        { name: "Lerbs" },
        { name: "Kaiser+Kraft" },
        { name: "City Link" }
      ]
    },
    {
      category: "Healthcare",
      icon: Heart,
      clients: [
        { name: "Wrizto Healthcare" },
        { name: "Visby Medical" }
      ]
    },
    {
      category: "Telecom",
      icon: Smartphone,
      clients: [
        { name: "Verizon" }
      ]
    },
    {
      category: "Retail",
      icon: Store,
      clients: [
        { name: "E-zone" },
        { name: "HomeTown" },
        { name: "qSaudi.com" },
        { name: "Vilcart" },
        { name: "Apna Chotu" }
      ]
    },
    {
      category: "Manufacturing",
      icon: Factory,
      clients: [
        { name: "Bosch" },
        { name: "Indiabulls IbLED" }
      ]
    },
    {
      category: "Chemicals",
      icon: TestTube,
      clients: [
        { name: "Welspun" }
      ]
    }
  ];

  const certifications = [
    { name: "ISO 27001", icon: Shield },
    { name: "AWS Partner", icon: Award },
    { name: "SAP Partner", icon: Award }
  ];

  return (
    <section className="py-8 sm:py-12 md:py-16 bg-gradient-to-br from-background via-secondary/5 to-primary/3 border-y border-secondary/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header - Temporarily hidden
        <div className="text-center mb-6 sm:mb-8 md:mb-10">
          <Badge className="mb-2 sm:mb-3 bg-primary/10 text-primary border-primary/20 text-xs sm:text-sm px-3 sm:px-4 py-1 sm:py-1.5">
            Trusted by Industry Leaders
          </Badge>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2 px-4">
            Global Enterprises Trust Smartborn
          </h2>
          <p className="text-xs sm:text-sm md:text-base text-muted-foreground max-w-2xl mx-auto px-4">
            Partnering with leading organizations across 25+ industries worldwide
          </p>
        </div>
        */}

        {/* Client Categories Grid - Temporarily hidden
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {clientCategories.map((category, categoryIndex) => (
            <div
              key={categoryIndex}
              className="bg-white/90 backdrop-blur-sm border-2 border-border/50 rounded-xl p-5 hover:shadow-xl hover:border-primary/40 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center gap-2 mb-4 pb-3 border-b border-border/50">
                <category.icon className="h-5 w-5 text-primary" />
                <h3 className="text-sm font-bold text-foreground">{category.category}</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {category.clients.map((client, clientIndex) => (
                  <div
                    key={clientIndex}
                    className="inline-flex items-center justify-center min-w-[80px] px-3 py-2 bg-white/90 backdrop-blur-sm border border-border/40 rounded-lg hover:bg-primary/5 hover:border-primary/40 hover:shadow-md transition-all duration-200"
                    title={client.name}
                  >
                    <span className="text-xs font-semibold text-foreground/80 tracking-tight text-center leading-tight">
                      {client.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        */}

        {/* Certifications - Temporarily hidden
        <div className="pt-6 border-t border-border/50">
          <div className="text-center mb-4">
            <h4 className="text-base md:text-lg font-semibold text-foreground mb-1">
              Certified & Recognized
            </h4>
            <p className="text-xs text-muted-foreground">Enterprise-grade partnerships and certifications</p>
          </div>
          
          <div className="flex flex-wrap justify-center items-center gap-3">
            {certifications.map((cert, index) => (
              <div
                key={index}
                className="flex items-center gap-2 px-3 py-1.5 bg-white/80 backdrop-blur-sm border border-primary/20 rounded-full hover:shadow-md hover:border-primary/40 transition-all duration-300"
              >
                <cert.icon className="h-3.5 w-3.5 text-primary" />
                <span className="text-xs font-medium text-foreground">{cert.name}</span>
              </div>
            ))}
          </div>
        </div>
        */}
      </div>
    </section>
  );
};

export default ClientLogos;
